import { DirectiveOptions, DirectiveFunction } from 'vue';

import { DomPurify } from '@/services/dom-purify/dom-purify';

const updateComponent: DirectiveFunction = function (el, binding) {
  const currentValue = binding.value;
  if (binding.oldValue === currentValue) {
    return;
  }
  el.innerHTML = DomPurify.sanitize(currentValue);
};

export const purifyHtml: DirectiveOptions = {
  inserted: updateComponent,
  update: updateComponent
};
